
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import CodeInput from 'vue-verification-code-input'

@Component({
  components: { CodeInput }
})
export default class AppCodeInput extends Vue {
  @Prop({ type: Boolean, default: false })
  private readonly loading!: boolean

  private get field() {
    return this.$refs.field as CodeInput
  }

  reset() {
    this.field.values = [null, null, null, null, null, null]
    const inputs = this.field.$refs.input_0 as HTMLInputElement[]
    inputs[0].focus()
  }
}
